import { render, staticRenderFns } from "./LaboratoriumRegist.vue?vue&type=template&id=0183b196&scoped=true"
import script from "./LaboratoriumRegist.vue?vue&type=script&lang=js"
export * from "./LaboratoriumRegist.vue?vue&type=script&lang=js"
import style0 from "./LaboratoriumRegist.vue?vue&type=style&index=0&id=0183b196&prod&lang=scss"
import style1 from "./LaboratoriumRegist.vue?vue&type=style&index=1&id=0183b196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0183b196",
  null
  
)

export default component.exports